import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Menu, Icon, Button, Flag, Grid, Label, Portal, Segment, Divider, LabelProps, ButtonProps } from 'semantic-ui-react';
import { strings } from '../..';
import { ApplicationState } from '../..';
import * as Core from '../../core';

type OwnProps = {
    onLinguaClick: (event: React.MouseEvent<HTMLElement, MouseEvent>, data: LabelProps) => void,
    onLogout: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, data: ButtonProps) => void
}

const connector = connect(
    (state: ApplicationState) => {
        let anagraficheCount = 1;
        if (state.core.anagrafiche.anagrafica !== undefined && Array.isArray(state.core.auth.user!.profile.anagrafica)) {
            anagraficheCount = state.core.auth.user!.profile.anagrafica.length;
        }

        return ({
            lingua: state.core.lingua,
            userName: state.core.auth.user?.profile.email,
            anagraficheCount: anagraficheCount
        })
    },
    Core.actions,
)
type PropsFromRedux = ConnectedProps<typeof connector>

type MenuUserProps = 
    PropsFromRedux & 
    OwnProps

class MenuUser extends React.Component<MenuUserProps> {
    constructor(props: MenuUserProps) {
        super(props);

        this.renderCambiaAnagrafica = this.renderCambiaAnagrafica.bind(this);
        this.renderPopupTrigger = this.renderPopupTrigger.bind(this);
    }

    render() {
        const { userName, lingua } = this.props;

        return (
            <Menu.Menu position='right'>
                <Portal closeOnTriggerClick openOnTriggerClick trigger={this.renderPopupTrigger(userName)}>
                    <Segment style={{ right: '1%', position: 'fixed', top: '5%' }}>
                        <Grid stretched relaxed>
                            <Grid.Row>
                                <Grid.Column width='3' verticalAlign='middle'>{strings.core.header.lingua}</Grid.Column>
                                <Grid.Column width='6' stretched>
                                    <Label as='a' basic color={lingua === 'en' ? 'green' : undefined} onClick={this.props.onLinguaClick} lingua='en'>
                                        <Flag name='united kingdom' />
                                        English
                                    </Label>
                                </Grid.Column>
                                <Grid.Column width='7' stretched>
                                    <Label as='a' basic color={lingua === 'it' ? 'green' : undefined} onClick={this.props.onLinguaClick} lingua='it'>
                                        <Flag name='italy' />
                                        Italiano
                                    </Label>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        <Divider />
                        {this.renderCambiaAnagrafica()}
                        <div style={{ textAlign: 'right' }}>
                            <Button onClick={this.props.onLogout} icon labelPosition='right' color='green' style={{ width: 150 }}>
                                <Icon name='log out' />
                                {strings.core.header.logout}
                            </Button>
                        </div>
                    </Segment>
                </Portal>
            </Menu.Menu>
        );
    }

    renderCambiaAnagrafica() {
        const { anagraficheCount } = this.props;
        if (anagraficheCount > 1) {
            return (
                <React.Fragment>
                <div style={{ textAlign: 'right' }}>
                    <Button basic color='green' onClick={this.props.cambiaAnagrafica}>
                        <Icon name='building outline' />
                        {strings.core.header.cambioDitta}
                        <Icon name='arrow right' />
                    </Button>
                </div>                
                <Divider hidden />
                </React.Fragment>
            );
        }

        return <React.Fragment />
    }

    renderPopupTrigger(userName: string | undefined) {
        return (
            <Menu.Item>
                <Icon name='user' />
                {userName}
                <Icon name='caret down' />
            </Menu.Item>
        );
    }
}

export default connector(MenuUser);
